import React from 'react'
import './loader.css'
import { useSelector } from 'react-redux'
import StoreSelectors from '../../utils/constants/StoreSelectors.constants'

const Loader = () => {

    const { isLoaderVisible, loaderMessage } = useSelector(StoreSelectors.LOADER_STATE)
    
    return (
        <div hidden={!isLoaderVisible} className='backdrop-bg mfLoader'>
            <div className="position-relative w-100 h-100">
                <div className='position-vh-center bg-white p-4 rounded loader-container d-flex align-items-center justify-content-center flex-column'>
                    <span className="loader mt-3"></span>
                    <p hidden={ loaderMessage?.length === 0 } className="mb-0 mt-3 font-md primary-text-black text-capitalize weight-500 text-center loader-message"> { loaderMessage } </p>
                </div>
            </div>
        </div>
    )
}

export default Loader